import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import CallButton from "../components/CallButton";
import { Outlet } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const HIDDEN_NAVBAR_PATHS = ['/sport-performance', '/fisio-sport'];

export default function MainLayout() {
  const location = useLocation();
  const hideNavbar = HIDDEN_NAVBAR_PATHS.includes(location.pathname);

  useEffect(() => {
    if (location.pathname !== "/") {
      document.getElementById("hero-loader")?.remove();
    }
  }, [location.pathname]);

  return (
    <>
        {!hideNavbar && <Navbar />}
        <Outlet />
        <Footer />
        <CallButton />
    </>
  );
}